import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import TargetSection from './components/TargetSection';
import ProductSection from './components/ProductSection';
import CustomizationSection from './components/CustomizationSection';
import AchievementsSection from './components/AchievementsSection';
import ReviewsSection from './components/ReviewsSection';
import PricingSection from './components/PricingSection';
import OrderStepsSection from './components/OrderStepsSection';
import LineOfferSection from './components/LineOfferSection';
import FaqSection from './components/FaqSection';
import FooterCta from './components/FooterCta';
import StickyLineButton from './components/StickyLineButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <HeroSection />
      <StatsSection />
      <TargetSection />
      <ProductSection />
      <CustomizationSection />
      <AchievementsSection />
      <ReviewsSection />
      <PricingSection />
      <OrderStepsSection />
      <LineOfferSection />
      <FaqSection />
      <FooterCta />
      <StickyLineButton />
    </div>
  );
}
